import styled from "styled-components";
import * as base from "../../styles/base";
import { media } from "../../styles/utils";

export const EarlyAccess = styled.div.attrs({
  className: "early-access-wrapper"
})`
  width: 87.5%;
  /* max-width: 570px; */
  margin: 0 auto;
  ${media.forDesktopOnly`
    width: 100%;
  `
  }
`;
export const EarlyAccessTitle = base.Title.extend`
  font-family: ${base.custom_font_family};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  font-size: 20px;
  display: flex;
  justify-content: flex-start;
  padding: 62px 0 20px;
  margin: 60px auto 0;
  line-height: 1.3;
  letter-spacing: 1px;
  max-width: 570px;
  border-top: 1px solid white;
  ${media.forDesktopOnly`
    line-height: 1.31;
    font-size: 26px;
    justify-content: center;
    padding-top: 100px;
    margin-top: 100px;
  `}
`;
export const EarlyAccessDescription = base.Text.extend`
  font-family: ${base.custom_font_family};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0.017em;
  text-align: left;
  font-size: 14px;
  letter-spacing: 0.5px;
  ${media.forDesktopOnly`
    font-size: 20px;
    line-height: 1.3;
    text-align: center;
    letter-spacing: 1px;
    margin-bottom: 6px;
  `}
  ${media.forMobileOnly`
    margin: 0 auto 6px;
  `};
`;
export const EarlyAccessProductContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 30px 0 40px;
  margin: 0 auto;
  max-width: 1200px;
  ${media.forDesktopOnly`
    flex-wrap: nowrap;
    padding: 50px 0 100px;
    justify-content: center;
  `}
`;
export const EarlyAccessProduct = styled.div.attrs({
  key: props => props.key || "0"
})`
  padding: 0 15px;
  width: 45%;
  margin-bottom: 6px;
  cursor: ${props => (!!props.clickable ? "pointer" : "initial")};
  ${media.forMobileOnly`
    width: 46.5%;
    padding: 0;
    margin-bottom: 20px;
    text-align: left;
  `};
`;
export const EarlyAccessProductImage = styled.img`
  width: 100%;
  background-color: transparent;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  margin-bottom: 5px;
  background-image: url('${props => props.src || ""}');
`;
export const EarlyAccessProductGender = styled.div`
  font-size: 15px;
  margin-bottom: 5px;
  color: #acacac;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: 0.5px;
  ${media.forMobileOnly`
    font-size: 10px;
  `};
`;
export const EarlyAccessProductName = styled.div`
  font-size: 15px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.4;
  letter-spacing: 0.5px;
  ${media.forMobileOnly`
    font-size: 10px;
  `};
`;
export const RsvpWrapper = styled.div`
  font-family: ${base.custom_font_family};
  color: black;
  margin: 0 auto 75px;
  width: 88.75%;
  max-width: 768px;
`;



// WEBPACK FOOTER //
// ./src/components/early_access_products/styled_early_access_products.js